// react import
import PropTypes from 'prop-types';

// ==============================|| FILEMNGR CUSTOM MUI ICON ||============================== //

const FileMngrCustomMuiIcon = ({ icon: Component, ...props }) => <Component {...props} />;

FileMngrCustomMuiIcon.propTypes = {
    icon: PropTypes.any
};

export default FileMngrCustomMuiIcon;
